<script setup>
import Cookies from 'js-cookie';
import { inject, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { BaseLink, LoadingOverlay, MapWrapper } from '@/app/components';

const { returnToProject } = inject('config');
const store = useStore();
const mql = window.matchMedia('(min-width: 46.25em)');

store.commit('projectsMap/SET_REQUEST_SUMMARY_FLAG', false);

onBeforeMount(() => {
  if (mql.matches && !Cookies.get('projectMapUserGuideVisited')) {
    store.dispatch('projectsMap/toggleUserGuideVisibility', true);
  }
});
</script>

<template>
  <div class="c-planned-project-area">
    <MapWrapper>
      <BaseLink :href="returnToProject.url" :modifiers="['form']">
        {{ returnToProject.label }}
      </BaseLink>
    </MapWrapper>
  </div>
  <LoadingOverlay />
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/units';

.c-planned-project-area {
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>
